import React, { Component } from 'react';
import { query, repository, subscribe } from '@trlogic/client-js';
import { InstanceContainer } from '../../../../config/binding/InstanceBinding';
import Injectables from '../../../../constant/Injectables';
import { MLOpsModelResult, MLOpsModelResultFeature } from '../../../../domain/mlops/MLOpsDomains';
import CollectionNames from '../../../../constant/CollectionNames';
import { RootState } from '../../../../redux/store';
import { AiModelState } from '../../../../redux/reducers/AiModelReducer';
import { connect, ConnectedProps } from 'react-redux';
import CustomTable, { CustomColumnProps } from '../../../custom/CustomTable';
import FormicaLabel from '../../../custom/FormicaLabel';
import CustomTableContentWrapper from '../../../custom/CustomTableContentWrapper';
import QueryableRepository = repository.QueryableRepository;
import QueryBuilder = query.QueryBuilder;
import and = query.and;
import eq = query.eq;

class MLOpsResultsTable extends Component<Props, State> {
  public state: State = new State();
  private mlopsResultSubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;

  private readonly repository: QueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  render() {
    console.log('render');
    return (
      <div className={''}>
        <FormicaLabel label={'Results'} />
        <CustomTable columns={this.getColumns()} value={this.state.results || []} />
      </div>
    );
  }

  public componentDidMount() {
    this.startTracker();
  }

  public componentWillUnmount() {
    this.stopTracker();
  }

  private startTracker = () => {
    const {
      aiModel: { aiModel, isUpdate },
    } = this.props;
    if (!isUpdate) {
      this.setState({ loading: false });
      return;
    }
    const query = QueryBuilder.select()
      .from(CollectionNames.AI_RESULTS)
      .where(and(eq('name', aiModel.name), eq('version', aiModel.version)))
      .build();
    this.mlopsResultSubscription = subscribe.Formica.subscribe(CollectionNames.AI_RESULTS, query);
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.mlopsResultSubscription]);
  };

  private stopTracker = () => {
    this.mlopsResultSubscription?.ready();
    this.computation?.stop();
  };

  private tracker = () => {
    if (this.mlopsResultSubscription?.ready()) {
      this.buildData();
    }
  };

  private buildData = async () => {
    const {
      aiModel: { aiModel },
    } = this.props;
    const query = QueryBuilder.select()
      .from(CollectionNames.AI_RESULTS)
      .where(and(eq('name', aiModel.name)))
      .build();
    const results: MLOpsModelResult[] | undefined = await this.repository.findMany(query);

    this.setState({ results, loading: false });
  };

  private getColumns = (): CustomColumnProps[] => {
    return [
      {
        field: 'name',
        header: 'name',
        className: 'min-w-[7%]',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.name} />;
        },
      },
      {
        field: 'version',
        header: 'Version',
        className: 'min-w-[7%]',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.version.toString()} />;
        },
      },
      {
        field: 'model',
        header: 'Model',
        className: 'min-w-[22%]',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.model.toString()} />;
        },
      },
      {
        field: 'leader',
        header: 'Leader',
        className: 'min-w-[7%]',
      },
      {
        field: 'mse',
        className: 'min-w-[12%]',
        header: 'MSE',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.mse.toString()} />;
        },
      },
      {
        field: 'rmse',
        className: 'min-w-[12%]',
        header: 'RMSE',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.rmse.toString()} />;
        },
      },
      {
        field: 'nobs',
        className: 'min-w-[7%]',
        header: 'Nobs',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.nobs.toString()} />;
        },
      },
      {
        field: 'r2',
        className: 'min-w-[12%]',
        header: 'R2',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.r2.toString()} />;
        },
      },
      {
        field: 'mrd',
        className: 'min-w-[12%]',
        header: 'MRD',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.mrd.toString()} />;
        },
      },
      {
        field: 'mae',
        className: 'min-w-[12%]',
        header: 'MAE',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.mae.toString()} />;
        },
      },
      {
        field: 'rmsle',
        className: 'min-w-[12%]',
        header: 'RMSLE',
        body: (value: MLOpsModelResult) => {
          return <CustomTableContentWrapper text={value.rmsle.toString()} />;
        },
      },
    ];
  };
}

class State {
  results: MLOpsModelResult[] = [];
  loading: boolean = true;
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  aiModel: state.aiModel as AiModelState,
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(MLOpsResultsTable);
